import {
  TOI_LIVE_DOMAIN,
  // IMAGE_URL,
  // TOI_SITE_NAME,
  // TOI_SEO_DOMAIN,
} from '../../constants';

const removeSpecialChar = txt => {
  if (txt && typeof txt === 'string') {
    txt.replace(/"/, '');
  } else {
    txt = '';
  }
  return txt;
};

// const getAuthorDetails = data => {
//   if (
//     data &&
//     data.audetails &&
//     data.audetails.primary &&
//     data.audetails.primary.name
//   ) {
//     return data.audetails.primary.name;
//   }
//   return '';
// };

// const getPhotstoryBody = data => {
//   let body = '';
//   if (data && Array.isArray(data.items) && data.items.length > 0) {
//     data.items.forEach(item => {
//       if (item && item.cap) {
//         body += item.cap;
//       }
//     });
//   }
//   const htmltagsRegex = /(<([^>]+)>)/gi;

//   body = body.replace(htmltagsRegex, '');

//   return body;
// };

const newsArticleSchema = {
  '@context': 'https://schema.org',
  '@type': 'NewsArticle',
  mainEntityOfPage: '',
  inLanguage: 'en',
  headline: '',
  keywords: '',
  url: '',
  datePublished: '',
  description: '',
  articleBody: '',
  author: {
    '@type': 'Thing',
    name: 'TIMESOFINDIA.COM',
  },
  publisher: {
    '@type': 'Organization',
    name: 'The Times Of India',
    url: 'https://timesofindia.indiatimes.com',
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.toiimg.com/photo/msid-58127550/58127550.jpg',
      width: 600,
      height: 60,
    },
  },
  image: {
    '@type': 'ImageObject',
    url: '',
    height: 900,
    width: 1600,
  },
};

const videoObjectSchema = {
  '@context': 'https://schema.org',
  '@type': 'VideoObject',
  name: '',
  duration: '',
  image: {
    '@type': 'ImageObject',
    url: '',
    height: 900,
    width: 1600,
  },
  contentUrl: '',
  embedUrl: '',
  description: '',
  datePublished: '',
  dateModified: '',
  thumbnailUrl: '',
  uploadDate: '',
  keywords: '',
  headline: '',
  author: {
    '@type': 'Thing',
    name: 'TIMESOFINDIA.COM',
  },
  interactionCount: '',
};

const generateVideoshowSchema = (
  VideoshowData,
  seoData,
  liveBroadcastSchema,
) => {
  videoObjectSchema.mainEntityOfPage = seoData?.canonical || VideoshowData?.wu;
  videoObjectSchema.name = removeSpecialChar(VideoshowData.hl);
  videoObjectSchema.duration = VideoshowData.du;
  videoObjectSchema.image.url = `${TOI_LIVE_DOMAIN}/photo/msid-${
    seoData.msid
  }/${seoData.msid}.jpg?resizemode=4`;
  videoObjectSchema.contentUrl = seoData.canonical;
  videoObjectSchema.embedUrl = `${TOI_LIVE_DOMAIN}/ifrmwdt/videoPlayer/${
    seoData.msid
  }`;
  videoObjectSchema.description = removeSpecialChar(seoData.description);
  videoObjectSchema.datePublished = seoData.publishtime;
  videoObjectSchema.dateModified = seoData.modified;
  videoObjectSchema.thumbnailUrl = `${TOI_LIVE_DOMAIN}/photo/msid-${
    seoData.msid
  }/${seoData.msid}.jpg?resizemode=4`;
  videoObjectSchema.uploadDate = seoData.publishtime;
  videoObjectSchema.keywords = seoData.key;
  videoObjectSchema.headline = removeSpecialChar(VideoshowData?.hl);
  videoObjectSchema.publication = [];
  const currentDate = Date.now();
  const unixTimestamp = VideoshowData.unixtimesstamp;
  const endTime = unixTimestamp + 24 * 60 * 60 * 1000;

  if (
    liveBroadcastSchema &&
    liveBroadcastSchema === 'Live Video' &&
    VideoshowData.unixtimesstamp &&
    currentDate <= endTime
  ) {
    videoObjectSchema.publication.push({
      '@type': 'BroadcastEvent',
      isLiveBroadcast: 'true',
      startDate: seoData.publishtime,
    });
  }
  videoObjectSchema.interactionCount = VideoshowData.viewed;

  if (
    VideoshowData?.media?.chapters?.item &&
    Array(VideoshowData.media.chapters.item)
  ) {
    videoObjectSchema.hasPart = [];
    videoObjectSchema.hasPart = VideoshowData.media.chapters.item.map(() => ({
      '@type': 'Clip',
      name: '',
      startOffset: '',
      endOffset: '',
      url: '',
    }));
  }
  newsArticleSchema.headline = removeSpecialChar(VideoshowData.hl);
  newsArticleSchema.keywords = seoData.key;
  newsArticleSchema.url = seoData.canonical;
  newsArticleSchema.datePublished = seoData.publishtime;
  newsArticleSchema.description = removeSpecialChar(seoData.description);
  newsArticleSchema.articleBody = removeSpecialChar(seoData.description);
  newsArticleSchema.image.url = `${TOI_LIVE_DOMAIN}/photo/msid-${
    seoData.msid
  }/${seoData.msid}.jpg?resizemode=4`;
  // <xsl:if test="$publishedDate - $updatedDate &gt; 60000">
  //   "dateModified": "<xsl:value-of select="dateUtil:getTimefromUnixMillisecs($dtFormat, //./mediaaudiovideo/strlastupd/@long_value)" />",
  // </xsl:if>;

  return JSON.stringify([videoObjectSchema, newsArticleSchema]);
};

export default generateVideoshowSchema;
